import { FormGroupName } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';

import { FormGroup } from '@angular/forms';

import { FormPackage } from '../../models/df-package';

@Component({
	selector: 'df-radio-button',
	templateUrl: './radio-button.component.html',
	styleUrls: ['./radio-button.component.scss']
})
export class RadioButtonComponent implements OnInit {
	@Input() package: FormPackage;
	@Input() form: FormGroup;
	@Input() config: FormGroup;
	public options = [];
	constructor() {}

	ngOnInit(): void {
		this.options = this.package.options;
	}
}
